"use client";

import MarketingNav from "@/components/marketing/MarketingNav";
import MarketingFooter from "@/components/marketing/MarketingFooter";
import { useLang } from "@/contexts/language-context";

export default function ContactClient() {
  const { t } = useLang();

  return (
    <>
      <MarketingNav />
      <main className="pt-36 pb-24 px-6">
        <div className="max-w-[720px] mx-auto">
          {/* Header */}
          <div className="mb-12">
            <div className="text-[11px] font-bold tracking-widest uppercase text-redy-orange mb-4">
              {t("Contact", "Contacto")}
            </div>
            <h1 className="text-4xl md:text-5xl font-black tracking-tight text-redy-charcoal mb-3">
              {t("Talk to a human", "Habla con una persona")}
            </h1>
            <p className="text-[15px] text-redy-secondary max-w-xl leading-relaxed">
              {t(
                "Questions about Redy, billing, or your account? Our team replies the same business day — no phone trees, no pressure.",
                "¿Preguntas sobre Redy, facturación o tu cuenta? Nuestro equipo responde el mismo día hábil — sin menús de voz ni presión."
              )}
            </p>
          </div>

          {/* Contact methods */}
          <div className="grid sm:grid-cols-2 gap-4 mb-4">
            {/* Email */}
            <div className="bg-white border border-black/5 rounded-[24px] p-7">
              <div className="text-[11px] font-black tracking-widest uppercase text-redy-secondary mb-2">
                {t("Email", "Correo")}
              </div>
              <a
                href="mailto:hello@useredy.com"
                className="text-[18px] font-black text-redy-charcoal hover:text-redy-orange transition-colors break-all"
              >
                hello@useredy.com
              </a>
              <p className="text-[13px] text-redy-secondary mt-2">
                {t("Sales, support, and billing.", "Ventas, soporte y facturación.")}
              </p>
            </div>

            {/* Phone */}
            <div className="bg-white border border-black/5 rounded-[24px] p-7">
              <div className="text-[11px] font-black tracking-widest uppercase text-redy-secondary mb-2">
                {t("Phone", "Teléfono")}
              </div>
              <a
                href="tel:+12345425633"
                className="text-[18px] font-black text-redy-charcoal hover:text-redy-orange transition-colors"
              >
                +1 (234) KICKOFF (+1 234-542-5633)
              </a>
              <p className="text-[13px] text-redy-secondary mt-2">
                {t("Mon–Fri, 9am–6pm Central Time.", "Lun–Vie, 9am–6pm hora central.")}
              </p>
            </div>
          </div>

          {/* Mailing address + business */}
          <div className="bg-white border border-black/5 rounded-[24px] p-7">
            <div className="text-[11px] font-black tracking-widest uppercase text-redy-secondary mb-3">
              {t("Mailing address", "Dirección postal")}
            </div>
            <address className="not-italic text-[15px] leading-relaxed text-redy-charcoal font-medium">
              Kickoff Business Solutions LLC{" "}
              <span className="text-redy-secondary font-normal">DBA Redy</span>
              <br />
              5900 Balcones Dr, Ste 100
              <br />
              Austin, TX 78731
              <br />
              {t("United States", "Estados Unidos")}
            </address>
          </div>

          {/* Help center pointer */}
          <p className="text-[14px] text-redy-secondary mt-8">
            {t("Looking for guides and answers? Visit our ", "¿Buscas guías y respuestas? Visita nuestro ")}
            <a href="/help" className="text-redy-charcoal font-bold underline">
              {t("Help Center", "Centro de Ayuda")}
            </a>
            .
          </p>
        </div>
      </main>
      <MarketingFooter />
    </>
  );
}
